// extracted by mini-css-extract-plugin
module.exports = {"container":"RelatedKeywords_container__Y9gfL","label":"RelatedKeywords_label__m2doS","keywords":"RelatedKeywords_keywords__8nP3v","keyword":"RelatedKeywords_keyword__9adq_"};